import { createTheme, Theme } from "@mui/material/styles";

export const BRAND = {
  navy: "#17384c",
  navyDark: "#0f2a3a",
  cyan: "#05bbe5",
  cyanDark: "#0592b5",
  background: "#f5f7fa",
  paper: "#ffffff",
  text: "#1f2937",
  muted: "#6b7280",
  divider: "#e5e7eb",
} as const;

export const FONT_FAMILY = "'Poppins', 'Segoe UI', Roboto, Arial, sans-serif";

const focusRing = { outline: `2px solid ${BRAND.cyan}`, outlineOffset: 2 };

// Tema global: formulário público, login e base do painel (densidade normal).
export const baseTheme: Theme = createTheme({
  palette: {
    primary: { main: BRAND.navy, contrastText: "#fff" },
    secondary: { main: BRAND.cyan, contrastText: "#fff" },
    background: { default: BRAND.background, paper: BRAND.paper },
    text: { primary: BRAND.text, secondary: BRAND.muted },
    divider: BRAND.divider,
  },
  typography: { fontFamily: FONT_FAMILY, button: { fontWeight: 600 } },
  shape: { borderRadius: 8 },
  components: {
    MuiButtonBase: { styleOverrides: { root: { "&.Mui-focusVisible": focusRing } } },
  },
});

// Tema do painel (ThemeProvider aninhado no AppShell): compacto e sem caixa alta (spec §5, dúvida 5).
export const panelTheme: Theme = createTheme(baseTheme, {
  typography: { h1: { fontSize: 22, fontWeight: 700, lineHeight: 1.3 } },
  components: {
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { textTransform: "none" } } },
    MuiTextField: { defaultProps: { size: "small" } },
    MuiFormControl: { defaultProps: { size: "small" } },
    MuiSelect: { defaultProps: { size: "small" } },
    MuiDialog: { defaultProps: { fullWidth: true } },
    MuiTooltip: { defaultProps: { arrow: true } },
    MuiTableCell: { styleOverrides: { head: { fontWeight: 600, color: "#374151", background: "#f8fafc" } } },
  },
});
